'use client';

import { useState } from 'react';
import Image from 'next/image';

const VIDEO_ID = 'vP1rcoeJTS4';
export const VIDEO_TITLE =
  'Why You Should Book Vacation Rentals Direct (Explained)';

// The aspect-ratio plugin replaces the theme scale, so aspect-video is not
// generated; the arbitrary value is.
const frameClassName =
  'relative block aspect-[16/9] w-full overflow-hidden rounded-2xl bg-primary-main';

// The play button unmounts on click; hand keyboard focus to the player.
const focusOnMount = (element: HTMLElement | null): void => {
  element?.focus();
};

export const VideoFacade = (): React.JSX.Element => {
  const [isPlaying, setIsPlaying] = useState(false);

  if (isPlaying) {
    return (
      <div className={frameClassName}>
        <iframe
          ref={focusOnMount}
          src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
          title={VIDEO_TITLE}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="h-full w-full"
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      aria-label={`Play video: ${VIDEO_TITLE}`}
      onClick={() => setIsPlaying(true)}
      className={`${frameClassName} group focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-primary-main`}
    >
      <Image
        src="/assets/img/about/video-thumbnail.jpg"
        alt="Sunset over a beach with the words: they have more resources to make your stay exceptional"
        fill
        sizes="(min-width: 1152px) 1088px, 100vw"
        className="object-cover"
      />
      <span className="absolute left-1/2 top-1/2 flex h-9 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-primary-main transition-colors group-hover:bg-white sm:h-[72px] sm:w-[134px]">
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="ml-0.5 h-4 w-4 sm:ml-1 sm:h-8 sm:w-8"
        >
          <path d="M6 3.5v17a1 1 0 0 0 1.52.85l13.6-8.5a1 1 0 0 0 0-1.7L7.52 2.65A1 1 0 0 0 6 3.5Z" />
        </svg>
      </span>
    </button>
  );
};
